import { getApiErrorMessage, getErrorReason } from "shared/utils";
import type { ApiError } from "shared/utils";

// Тексты по машинному коду { "reason" } — приоритетнее message бэка.
const REASON_MESSAGES: Record<string, string> = {
  ticket_not_found: "Request not found.",
  ticket_closed: "This request is closed.",
  ticket_rate_limited: "Too many requests. You can create up to 10 per day.",
  validation_error: "Please check the entered data.",
};

const DEFAULT_MESSAGE = "Something went wrong. Please try again.";

export const getTicketErrorMessage = (error: ApiError): string | null => {
  const reason = getErrorReason(error);
  const reasonMessage = reason ? REASON_MESSAGES[reason] : undefined;
  return reasonMessage ?? getApiErrorMessage(error, {}, DEFAULT_MESSAGE);
};
